import i18n from 'modules/core/lib/i18n'

import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import LocationInput from './LocationInput'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  onPlaceSelected?: (place: { lat: number; lng: number }) => void
  onInputChange?: () => void
}

const FromField = (props: Props) => {
  return (
    <LocationInput
      {...props}
      fieldName="from"
      label={i18n.t('expenses_v2.forms.fields.from.label')}
      placeholder={i18n.t('expenses_v2.forms.fields.from.placeholder')}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(FromField, 'from'))
